var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.025 5.72119H4.63333C3.45513 5.72119 2.5 6.67632 2.5 7.85452V16.2129C2.5 17.3911 3.45513 18.3462 4.63333 18.3462H15.025C16.2032 18.3462 17.1583 17.3911 17.1583 16.2129V7.85452C17.1583 6.67632 16.2032 5.72119 15.025 5.72119Z",
    fill: "#E5DDF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72498 6.89602C5.72498 5.40436 5.81664 3.82102 6.64998 2.58769C7.77498 0.921024 10.2333 0.329357 11.9916 1.30436C13.5833 2.19602 14.2 5.12102 13.9083 7.22102",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.8333H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.a5d57e050fb69d9298fd58f9e969abdc.svg";
export { ForwardRef as ReactComponent };